var _path, _path2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconChunks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.6605 35.959H30.0318C27.5289 35.959 25.5 37.7481 25.5 39.955V68.0479C25.5 70.2548 27.5289 72.0439 30.0318 72.0439H51.6605C54.1634 72.0439 56.1923 70.2548 56.1923 68.0479V39.955C56.1923 37.7481 54.1634 35.959 51.6605 35.959Z",
    fill: "url(#paint0_linear_1846_70114)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6605 35.959H30.0318C27.5289 35.959 25.5 37.7481 25.5 39.955V68.0479C25.5 70.2548 27.5289 72.0439 30.0318 72.0439H51.6605C54.1634 72.0439 56.1923 70.2548 56.1923 68.0479V39.955C56.1923 37.7481 54.1634 35.959 51.6605 35.959Z",
    fill: "url(#paint1_linear_1846_70114)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1846_70114)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.9683 29.5156H45.378C42.8752 29.5156 40.8462 31.3047 40.8462 33.5116V74.4875C40.8462 76.6944 42.8752 78.4835 45.378 78.4835H77.9683C80.4711 78.4835 82.5 76.6944 82.5 74.4875V33.5116C82.5 31.3047 80.4711 29.5156 77.9683 29.5156Z",
    fill: "url(#paint2_linear_1846_70114)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.378 29.9411H77.9683C80.288 29.9411 82.0746 31.5884 82.0746 33.5116V74.4875C82.0746 76.4107 80.288 78.0581 77.9683 78.0581H45.378C43.0582 78.0581 41.2716 76.4107 41.2716 74.4875V33.5116C41.2716 31.5884 43.0582 29.9411 45.378 29.9411Z",
    stroke: "url(#paint3_linear_1846_70114)",
    strokeWidth: 0.85086
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1846_70114",
    x: 25.5307,
    y: 14.2001,
    width: 72.2848,
    height: 79.5997,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.65774
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1846_70114"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1846_70114",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1846_70114",
    x1: 20.7601,
    y1: 64.3875,
    x2: 86.2123,
    y2: 20.8546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF6700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1846_70114",
    x1: 20.7601,
    y1: 64.3875,
    x2: 86.2123,
    y2: 20.8546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF6700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1846_70114",
    x1: 43.1978,
    y1: 75.719,
    x2: 86.0744,
    y2: 39.2466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.49
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1846_70114",
    x1: 43.7865,
    y1: 33.3669,
    x2: 84.6269,
    y2: 70.5124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChunks);
export default __webpack_public_path__ + "static/media/icon-chunks.3e4bded40f17b65e309f7b5786e4ac4b.svg";
export { ForwardRef as ReactComponent };